import * as THREE from 'three';
import calculateSlicePerimeter from './calculateSlicePerimeter';

export interface FindMaxPerimeterOptions {
    slices: number;
}

export default function findMaximumPerimeter(
    mesh: THREE.Mesh,
    options: FindMaxPerimeterOptions = { slices: 50 }
): number {

    // Update the world matrix of the mesh to ensure accurate calculations
    if (!mesh.geometry.boundingBox) {
        mesh.geometry.computeBoundingBox();
    }

    const boundingBox = mesh.geometry.boundingBox!.clone();
    boundingBox.applyMatrix4(mesh.matrixWorld);

    const minY = boundingBox.min.y;
    const maxY = boundingBox.max.y;
    const heightRange = maxY - minY;

    if (heightRange <= 1e-6) {
        // if the height range is negligible, calculate perimeter at minY only
        return calculateSlicePerimeter(mesh, minY);
    }

    const numSlices = Math.max(2, options.slices); // minimum 2 slices
    const stepHeight = heightRange / (numSlices - 1);

    let maxPerimeter = 0;

    // Calculate perimeter at each slice and track the maximum
    for (let i = 0; i < numSlices; i++) {
        const currentHeight = minY + (i * stepHeight);

        // Calculate perimeter at the current slice height
        const perimeter = calculateSlicePerimeter(mesh, currentHeight);

        if (perimeter > maxPerimeter) {
            maxPerimeter = perimeter;
        }
    }

    //circumferenceFromMesh(mesh);
    return maxPerimeter;
}


/*
export const circumferenceFromMesh = (mesh: THREE.Mesh): void => {
    const pos = (mesh.geometry as THREE.BufferGeometry).getAttribute('position') as THREE.BufferAttribute | undefined;
    if (!pos) {
        console.log("----------circumference-->", 0);
        return
    }
    const v = new THREE.Vector3();
    let sum = 0, n = pos.count;
    for (let i = 0; i < n; i++) {
        v.fromBufferAttribute(pos, i);
        sum += Math.hypot(v.x, v.z);
    }
    const r = sum / n; // average radius in XZ
    console.log("----------circumference", 2 * Math.PI * r);
};*/
